import { flushSync } from 'react-dom';

export function startViewTransition(update: () => void, scopeElement?: Element | null): void {
  const scope = scopeElement || document;
  const startViewTransitionFn = getStartViewTransitionFn(scope);

  if (startViewTransitionFn) {
    startViewTransitionFn.call(scope, () => {
      flushSync(() => update());
    });
  } else {
    update();
  }
}

function getStartViewTransitionFn(
  scope: Element | Document,
): ((update: () => void) => void) | undefined {
  if ('startViewTransition' in scope && typeof scope.startViewTransition === 'function') {
    return scope.startViewTransition as (update: () => void) => void;
  }
}
